/* PLAKTON · pk-story.js — animaciones de la página «La empresa» */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aparición al entrar en pantalla */
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('[data-pk-reveal]');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.2 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Manifiesto: cada palabra se enciende según el scroll */
  function words(scope) {
    (scope || document).querySelectorAll('[data-pk-words]').forEach(function (p) {
      if (p.dataset.ready) return;
      p.dataset.ready = '1';
      var txt = p.textContent.trim().split(/\s+/);
      p.innerHTML = txt.map(function (w) { return '<span class="w">' + w.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>'; }).join(' ');
      if (reduce) return;
      var ws = p.querySelectorAll('.w');
      function tick() {
        var r = p.getBoundingClientRect(), vh = window.innerHeight;
        var prog = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
        var n = Math.round(prog * ws.length);
        for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('on', i < n);
      }
      window.addEventListener('scroll', function () { window.requestAnimationFrame(tick); }, { passive: true });
      tick();
    });
  }

  /* Compromisos: la imagen fija cambia con el texto activo */
  function commit(scope) {
    (scope || document).querySelectorAll('[data-pk-commit]').forEach(function (sec) {
      var steps = sec.querySelectorAll('[data-pk-step]'), pics = sec.querySelectorAll('[data-pk-pic]'), cnt = sec.querySelector('[data-pk-count]');
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = en.target.getAttribute('data-pk-step');
          steps.forEach(function (s) { s.classList.toggle('is-active', s === en.target); });
          pics.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pk-pic') === i); });
          if (cnt) cnt.textContent = ('0' + (Number(i) + 1)).slice(-2);
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* Portada: ligero parallax */
  function parallax() {
    var m = document.querySelector('[data-pk-parallax]');
    if (!m || reduce) return;
    window.addEventListener('scroll', function () {
      var y = Math.min(window.scrollY, window.innerHeight);
      m.style.transform = 'translate3d(0,' + (y * 0.25) + 'px,0)';
    }, { passive: true });
  }

  function init(scope) { reveal(scope); words(scope); commit(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); parallax(); }); else { init(); parallax(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
